import { ISubmitProps } from '../../../containers/FormContainer/types/internal';
import { getMapper } from './answerFieldMappers';
import { TMappedAnswersState } from '../types';

export const mapAnswersState = (props: ISubmitProps) => {
  return props.stepsHistory.reduce((acc, step) => {
    const stepCode = step.stepCode;
    const questionCode = props.stepsMap[stepCode].questionCode;
    const question = props.questionsMap[questionCode];
    const answer = props.answersState[question.answerField];

    if (!answer) {
      return acc;
    }

    const mapper = getMapper(question.type, question.answerType, question.answerField);

    return {
      ...acc,
      ...mapper(answer),
    };
  }, {} as TMappedAnswersState);
};
